export const color = {
  black: '#1C1C1C',
  white: '#FFFFFF',
  blackO30: '#1C1C1C4D', // 30% opacity
  blackO50: '#1C1C1C80', // 50% opacity
  blackO70: '#1C1C1CB3',
  blackO10: '#1C1C1C1A',

  /* Customizable colors */
  headerText: '#FFFFFF',
  bodyText: '#1C1C1C',
  primaryButtonText: '#FFFFFF',
  background: '#FFFFFF',
  actionBarBackground: '#FFFFFF',

  /* Customizable brand colors */
  primary130: '#BD3638',
  primary120: '#C7393B',
  primary110: '#D63D3F',
  primary70: '#E56165',
  primary30: '#F1ACAE',
  primary10: '#FAEAEB',
  primary05: '#FAF1F0',
  primary080: 'rgba(189, 54, 56, 0.8)',

  secondary130: '#163898',
  secondary110: '#2858DC',
  secondary05: '#EFF4FB',
  secondary05O75: '#E7EEF8BF', // 75% opacity

  warn130: '#B95D17',
  warn110: '#D66B1F',
  warn05: '#FCF5EE',
  warn05O75: '#FAF0E5BF', // 75% opacity

  error130: '#CA4B1C',
  error110: '#E44D2F',
  error05: '#FBF2EF',
  error05O75: '#FAEEEBBF', // 75% opacity

  success130: '#186235',
  success110: '#1D723E',
  success30: '#E1F0E6',
  success05: '#F3F7F4',
  success05O75: '#EDF3EEBF', // 75% opacity

  grey100: '#595959',
  grey90: '#6A6A6A',
  grey80: '#7A7A7A',
  grey70: '#8B8B8B',
  grey60: '#9B9B9B',
  grey50: '#ACACAC',
  grey40: '#BDBDBD',
  grey30: '#CDCDCD',
  grey20: '#DEDEDE',
  grey10: '#EFEFEF',
  grey07: '#F4F4F4',
  grey05: '#F7F7F7',
  grey05O75: '#F5F5F5BF', // 75% opacity

  linkedIn: '#0077b5',
}

export type ThemeColor = keyof typeof color

export const shadow = {
  default: '0px 4px 10px rgba(0, 0, 0, 0.08)',
  bottom: '0px 4px 7px rgba(0, 0, 0, 0.25)',
  top: '0px -1px 7px rgba(28, 28, 28, 0.08)',
  primaryHover: 'none',
  tertiaryHover: 'none',
  text: `-0.2px -0.2px 0  rgba(0, 0, 0, 0.08),
    0.2px -0.2px 0  rgba(0, 0, 0, 0.08),
    -0.2px 0.2px 0  rgba(0, 0, 0, 0.08),
    0.2px 0.2px 0  rgba(0, 0, 0, 0.08)`,
}

export const trueWhite = '#FFFFFF'
export const trueBlack = '#000000'

export const lightThemeAlertColors = {
  '130': '#000000',
  '110': '#000000',
  '05': '#0000001A',
  '05O75': '#0000001A',
}

export const darkThemeAlertColors = {
  '130': '#FFFFFF',
  '110': '#FFFFFF',
  '05': '#FFFFFF33',
  '05O75': '#FFFFFF33',
}

export const darkThemeGreys = {
  grey100: '#FFFFFFFF',
  grey90: '#FFFFFFE6',
  grey80: '#FFFFFFCC',
  grey70: '#FFFFFFB3',
  grey60: '#FFFFFF99',
  grey50: '#FFFFFF80',
  grey40: '#FFFFFF66',
  grey30: '#FFFFFF4D',
  grey20: '#FFFFFF33',
  grey10: '#FFFFFF26',
  grey07: '#FFFFFF1A',
  grey05: '#FFFFFF12',

  bodyText: '#FFFFFF',
  actionBarBackground: '#FFFFFF12',
}

export const lightThemeGreys = {
  grey100: '#000000FF',
  grey90: '#000000E6',
  grey80: '#000000CC',
  grey70: '#000000B3',
  grey60: '#00000099',
  grey50: '#00000080',
  grey40: '#00000066',
  grey30: '#0000004D',
  grey20: '#00000033',
  grey10: '#0000001A',
  grey07: '#00000012',
  grey05: '#0000000D',

  bodyText: '#000000',
  actionBarBackground: '#0000000D',
}
